import { Component, OnInit, Output , EventEmitter} from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-scam-info',
  templateUrl: './scam-info.component.html',
  styleUrls: ['./scam-info.component.scss']
})
export class ScamInfoComponent implements OnInit {
  @Output() isProceedClicked = new EventEmitter();
  authoringContentData:any;

  constructor( private manageLineSvc: ManageLineService, private utilsSvc: UtilsService) { }

  ngOnInit() {    
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
  }

  onClickClose() {
    this.manageLineSvc.close();
    this.isProceedClicked.emit(false);
  }
  onClickPropceed() {
    this.manageLineSvc.close();
    this.isProceedClicked.emit(true);
  }
  

}
